import fscreen from 'fscreen'

export default function video (document, moduleHTML, appEventEmitter) {
  const video = moduleHTML.querySelector('video')
  const playButton = moduleHTML.querySelector('[data-js-video-play-button]')
  const pauseIcon = moduleHTML.querySelector('[data-js-video-control-pause]')
  const playIcon = moduleHTML.querySelector(`[data-js-video-control-play]`)
  const volumeSlider = moduleHTML.querySelector('[data-js-video-control-volume]')
  const progressSlider = moduleHTML.querySelector('[data-js-video-control-progress]')
  const fullscreenButton = moduleHTML.querySelector('[data-js-video-control-fullscreen]')
  let progressSliderMoving = false
  let clickedOnce = false
  const videoSrc = video.getElementsByTagName('source')[0].src
  const videoFileName = videoSrc.substring(videoSrc.lastIndexOf('/') + 1)
  const locationPath = window.location.pathname

  if (!video || !playIcon || !pauseIcon || !playButton || !volumeSlider || !progressSlider) {
    console.error('Video: Something is wrong, could not find all video elements needed.')
    return
  }

  pauseIcon.style.display = 'none'

  listenToVideoTogglePlay()
  listenToVideoProgress()
  listenToVideoClick()
  listenToScrub()
  listenToPlayIconClick()
  listenToPauseIconClick()
  listenToPlayButtonOverlayClick()
  listenToVolumeSlider()
  listenToFullscreenButtonClick()
  listenToPageLeave()

  function listenToVideoTogglePlay () {
    video.addEventListener('play', handleVideoTogglePlay)
    video.addEventListener('pause', handleVideoTogglePlay)
  }

  function listenToVideoClick () {
    video.addEventListener('click', togglePlay)
  }

  function listenToVideoProgress () {
    video.addEventListener('timeupdate', handleProgress)
  }

  function listenToScrub () {
    progressSlider.addEventListener('click', handleScrub)
    progressSlider.addEventListener('mousedown', () => { progressSliderMoving = true })
    progressSlider.addEventListener('mouseup', () => { progressSliderMoving = false })

    progressSlider.addEventListener('mousemove', (event) => {
      if (progressSliderMoving) {
        handleScrub(event)
      }
    })
  }

  function listenToPlayIconClick () {
    playIcon.addEventListener('click', togglePlay)
    updateControlIcons()
  }

  function listenToPauseIconClick () {
    pauseIcon.addEventListener('click', togglePlay)
    updateControlIcons()
  }

  function listenToPlayButtonOverlayClick () {
    playButton.addEventListener('click', togglePlay)
  }

  function listenToVolumeSlider () {
    volumeSlider.addEventListener('change', changeVolume)
    volumeSlider.addEventListener('input', changeVolume)
  }

  function listenToFullscreenButtonClick () {
    fullscreenButton.addEventListener('click', enterFullscreen)
  }

  function listenToPageLeave () {
    window.addEventListener('beforeunload', handlePageLeave)
  }

  function handleVideoTogglePlay () {
    updatePlayButtonOverlay()
    updateControlIcons()
  }

  function updatePlayButtonOverlay () {
    if (video.paused) {
      playButton.style.display = 'block'
      return
    }

    playButton.style.display = 'none'
  }

  function updateControlIcons () {
    if (video.paused) {
      playIcon.style.display = 'inline'
      pauseIcon.style.display = 'none'
      return
    }

    playIcon.style.display = 'none'
    pauseIcon.style.display = 'inline'
  }

  function togglePlay () {
    // needed for an issue in chrome where the video player behaves randomly when in full screen mode
    if (document.webkitFullscreenElement) return

    if (video.paused) {
      video.play()
      if (clickedOnce) {
        clickedOnce = true
        addToGATracking('Video Play', `Played Video: ${videoFileName} on ${locationPath}`, 'Video File Name: ' + 'Video Played')
      }
    } else {
      video.pause()
    }
  }

  function handleProgress () {
    const percent = (video.currentTime / video.duration) * 100
    const progressFiller = progressSlider.children.item(0)
    progressFiller.style.width = `${percent}%`
  }

  function handleScrub (event) {
    const scrubTime = (event.offsetX / progressSlider.offsetWidth) * video.duration
    video.currentTime = scrubTime
  }

  function handlePageLeave () {
    if (clickedOnce) {
      addToGATracking('Video Play Duration', `Played Video File Name: ${videoFileName} ${video.currentTime}`, 'Video Play Duration')
    }
  }

  function changeVolume () {
    video.volume = volumeSlider.value
  }

  function enterFullscreen () {
    if (fscreen.fullscreenEnabled) {
      fscreen.requestFullscreen(video)
    }
  }

  function addToGATracking (eventCategory, eventAction, eventLabel) {
    //= ========================================
    //  Google Analytics Tracking analytics.js
    //= ========================================
    // eslint-disable-next-line
    if (!ga) {
      throw new Error('Video: Could not find the global ga function, this is usually provided by tag manager')
    }

    // send analytics to google
    // eslint-disable-next-line
    ga('send', {
      hitType: 'event',
      eventCategory: eventCategory,
      eventAction: eventAction,
      eventLabel: eventLabel
    })
  }
}
